import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { useGetRestockLogs } from "../../../../../../hooks/api/queries";
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { RestockDraftsTable } from "../../../../../../components/secondaryComponents/Restocks";

const RestockDrafts = () => {
  const { gotoPage } = useUrlSearch();
  const { data, isLoading } = useGetRestockLogs({
    queryParams: { status: "DRAFT" },
  });
  const restockDrafts = data?.data || [];
  const metaDetails = data?.meta || {};

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div className={globalStyles.tableWrapper}>
        <secondaryComponents.LoaderHelper
          isLoading={isLoading}
          classNames="mt-5"
        >
          <RestockDraftsTable
            metaDetails={metaDetails}
            restockDrafts={restockDrafts}
            gotoPage={gotoPage}
          />
        </secondaryComponents.LoaderHelper>
      </div>
    </div>
  );
};
export default RestockDrafts;
